import { useState } from 'react';
import type { Session } from '../../api/session';
import { SUPPORT_URL } from '../../app/config';
import type { TelegramApi } from '../../telegram/webapp';
import { BrandMark } from '../../ui/BrandMark';
import s from '../auth/auth.module.css';
import { JoinScreen } from '../more/JoinScreen';

const STEPS = [
  'Узнайте в управляющей компании номер объекта — посёлка, ЖК или бизнес-центра.',
  'Нажмите «Подать заявку», впишите номер и свой адрес.',
  'УК проверит заявку и добавит вас. После этого нажмите «Проверить ещё раз».',
];

/**
 * A resident without objects (scenario 4 of the login brief): the server created the account but no object
 * links it. The join request is the only way forward, so it is reachable right here, before the tab shell.
 */
export function NoObjectsScreen({ session, telegram, onRecheck, joinObjectId }: { session: Session; telegram: TelegramApi; onRecheck: () => void; joinObjectId?: number }) {
  // A посёлок link already names the object: go straight to the request.
  const [joining, setJoining] = useState(joinObjectId !== undefined);
  if (joining) return <JoinScreen session={session} telegram={telegram} objectId={joinObjectId} doneText="УК проверит её и добавит вас к адресу. Когда это случится, откройте приложение заново." />;

  return (
    <main className={s.screen}>
      <BrandMark />
      <h1 className={s.title}>Вы ещё не привязаны к адресу</h1>
      <p className={s.lead}>Вход выполнен, но управляющая компания пока не добавила ваш номер к объекту. Это делается один раз:</p>
      <ol className={s.steps}>
        {STEPS.map((text, i) => (
          <li key={i} className={s.step}>
            <span className={s.stepNo} aria-hidden="true">
              {i + 1}
            </span>
            {text}
          </li>
        ))}
      </ol>
      <div className={s.spacer} />
      <div className={s.actions}>
        <button type="button" className={s.primary} onClick={() => setJoining(true)}>
          Подать заявку
        </button>
        <button type="button" className={s.link} onClick={onRecheck}>
          Проверить ещё раз
        </button>
        <button type="button" className={s.link} onClick={() => telegram.openLink(SUPPORT_URL)}>
          Техподдержка
        </button>
      </div>
    </main>
  );
}
